import React, { useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Reviews from './pages/Reviews';
import Contact from './pages/Contact';
import Reservations from './pages/Reservations';

// Puente entre los ids usados en la app (navigate('about')) y las URLs reales.
const PATH_BY_ID = {
  home: '/',
  about: '/about',
  services: '/services',
  reviews: '/reviews',
  contact: '/contact',
  reservations: '/reservations',
};

const ID_BY_PATH = Object.fromEntries(
  Object.entries(PATH_BY_ID).map(([id, path]) => [path, id])
);

function Layout() {
  const routerNavigate = useNavigate();
  const location = useLocation();
  const mainRef = useRef(null);
  const isFirstRender = useRef(true);

  // Mantiene la misma firma navigate(id) que ya usan Navbar, Footer y las páginas.
  const navigate = (id) => routerNavigate(PATH_BY_ID[id] || '/');

  // Id de la sección actual, para resaltar el link activo en el Navbar.
  const page = ID_BY_PATH[location.pathname] || 'home';

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });

    // A11y: al cambiar de ruta (no en la carga inicial) movemos el foco al
    // contenido principal para que usuarios de teclado/lector no queden perdidos.
    if (!isFirstRender.current && mainRef.current) {
      mainRef.current.focus();
    }
    isFirstRender.current = false;
  }, [location.pathname]);

  return (
    <div>
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Navbar page={page} navigate={navigate} />
      <main id="main-content" ref={mainRef} tabIndex={-1}>
        <Routes>
          <Route path="/" element={<Home navigate={navigate} />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services navigate={navigate} />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/reservations" element={<Reservations />} />
          {/* Cualquier ruta desconocida vuelve al Home */}
          <Route path="*" element={<Home navigate={navigate} />} />
        </Routes>
      </main>
      <Footer navigate={navigate} />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}
